module.exports = __webpack_public_path__ + "img/Add FAQ Menu.9ef35826.png";